/**
 * KovaFit - Barra de compra fija en movil.
 *
 * No agrega al carrito por su cuenta: hace click en el boton real de Dawn.
 * Solo observa (no modifica) el boton y el precio de Dawn para copiarlos.
 */
if (!customElements.get('kf-sticky-atc')) {
  customElements.define(
    'kf-sticky-atc',
    class KfStickyAtc extends HTMLElement {
      connectedCallback() {
        if (this.ready || this.closest('.quick-add-modal')) return;

        // La columna de Dawn queda con 'transform' por la animacion de entrada,
        // y un position:fixed dentro de un transform deja de ser fijo a la
        // pantalla. Se mueve la barra a <body> (esto vuelve a llamar a
        // connectedCallback). Si Dawn re-renderiza la ficha, la barra vieja se
        // reemplaza por la nueva.
        if (this.parentElement !== document.body) {
          document.querySelectorAll('body > kf-sticky-atc').forEach((node) => node.remove());
          document.body.appendChild(this);
          return;
        }

        const sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
        this.productRoot = document.getElementById(`MainProduct-${sectionId}`);
        this.priceHost = document.getElementById(`price-${sectionId}`);
        this.button = this.querySelector('[data-kf-satc-btn]');
        this.label = this.querySelector('[data-kf-satc-label]');
        this.price = this.querySelector('[data-kf-satc-price]');
        if (!this.mainButton || !this.button) return;
        this.ready = true;

        this.sizeOption = (this.dataset.sizeOption || '').trim().toLowerCase();
        this.chooseLabel = this.dataset.chooseLabel || '';
        this.chosen = this.dataset.requireChoice !== 'true';

        this.onButtonClick = this.onButtonClick.bind(this);
        this.onOptionInteraction = this.onOptionInteraction.bind(this);
        this.button.addEventListener('click', this.onButtonClick);
        // Delegado en document: Dawn reemplaza el selector de variantes en cada cambio.
        document.addEventListener('click', this.onOptionInteraction);
        document.addEventListener('change', this.onOptionInteraction);

        this.buttonObserver = new MutationObserver(() => this.sync());
        this.buttonObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        if (this.priceHost) {
          this.priceObserver = new MutationObserver(() => this.syncPrice());
          this.priceObserver.observe(this.priceHost, { childList: true, subtree: true, characterData: true });
        }

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(([entry]) => this.setVisible(!entry.isIntersecting));
          this.visibilityObserver.observe(this.mainButton);
        }

        this.sync();
        this.syncPrice();
      }

      disconnectedCallback() {
        if (!this.ready) return;
        this.button.removeEventListener('click', this.onButtonClick);
        document.removeEventListener('click', this.onOptionInteraction);
        document.removeEventListener('change', this.onOptionInteraction);
        this.buttonObserver?.disconnect();
        this.priceObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        document.body.classList.remove('kf-satc-on');
        this.ready = false;
      }

      setVisible(visible) {
        this.classList.toggle('is-visible', visible);
        document.body.classList.toggle('kf-satc-on', visible);
      }

      isSizeControl(target) {
        if (!target || !this.productRoot || !this.productRoot.contains(target)) return false;
        if (!target.closest('variant-selects')) return false;
        let name = target.dataset?.optionName;
        if (target.tagName === 'SELECT') {
          name = target.options[target.selectedIndex]?.dataset.optionName;
        }
        return (name || '').trim().toLowerCase() === this.sizeOption;
      }

      onOptionInteraction(event) {
        if (this.chosen) return;
        const target = event.target.closest?.('input, select') || event.target;
        if (!this.isSizeControl(target)) return;
        this.chosen = true;
        this.sync();
      }

      sizeFieldset() {
        if (!this.productRoot) return null;
        for (const node of this.productRoot.querySelectorAll('variant-selects [data-option-name]')) {
          if ((node.dataset.optionName || '').trim().toLowerCase() === this.sizeOption) {
            return node.closest('fieldset, .product-form__input') || node;
          }
        }
        return this.productRoot.querySelector('variant-selects');
      }

      onButtonClick() {
        if (!this.chosen) {
          const target = this.sizeFieldset();
          if (target) {
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
            target.classList.remove('kf-satc-highlight');
            void target.offsetWidth;
            target.classList.add('kf-satc-highlight');
            setTimeout(() => target.classList.remove('kf-satc-highlight'), 1600);
          }
          return;
        }
        if (!this.mainButton.hasAttribute('disabled')) this.mainButton.click();
      }

      sync() {
        if (!this.chosen) {
          this.label.textContent = this.chooseLabel;
          this.button.disabled = false;
          return;
        }
        const text = this.mainButton.querySelector('span')?.textContent.trim();
        if (text) this.label.textContent = text;
        this.button.disabled = this.mainButton.hasAttribute('disabled');
      }

      syncPrice() {
        if (!this.priceHost || !this.price) return;
        const onSale = this.priceHost.querySelector('.price--on-sale');
        const node = onSale
          ? this.priceHost.querySelector('.price__sale .price-item--last')
          : this.priceHost.querySelector('.price__regular .price-item--regular');
        const text = node?.textContent.trim();
        if (text) this.price.textContent = text;
      }
    }
  );
}
